import "./style.css";

export interface TelephoneFieldProps {
  countries: Array<{ value: string; label: string }>;
  selectedCountry: { value: string; label: string };
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  changeCountry: (countryCode: string) => void;
  label: string;
  customClass?: string;
  isRequired?: boolean;
  id: string;
  placeholder?: string;
  errorMsg?: string;
  pattern?: string;
}

const TelephoneField = (props: TelephoneFieldProps) => (
  <div className=" telephone-field">
    <div className="mb-2 flex justify-between items-center">
      <span>
        <span
          className={`font-bold ${props.errorMsg ? "text-primary-red" : "text-grey-scale-slate"}`}
        >
          {props.label}
        </span>
        {props.isRequired && (
          <span className="font-bold text-accent-berry">*</span>
        )}
      </span>
      {props.errorMsg && (
        <span
          data-testid="telephone-input-error"
          className="text-primary-red text-sm italic"
        >
          {props.errorMsg}
        </span>
      )}
    </div>
    <div
      className={`flex items-center field !pl-0 !pr-0 ${props.errorMsg ? "!border-primary-red" : ""}`}
    >
      <div className="relative w-full flex items-center">
        <select
          data-testid="country-select"
          className="select-business-phone py-2 text-sm !w-22"
          value={props.selectedCountry.value}
          onChange={(e) => props.changeCountry(e.target.value)}
        >
          {props.countries.map((country, index) => (
            <option
              value={country.value}
              key={`country-code-${country.value}-${index}`}
            >
              {country.label} {country.value}
            </option>
          ))}
        </select>
        <input
          data-track="telephone-input"
          aria-describedby={props.label}
          data-testid="telephone-input"
          type="number"
          id={props.id}
          className="dropdown-input"
          placeholder={props.placeholder}
          required={props.isRequired}
          value={props.value}
          onChange={props.onChange}
          pattern={props.pattern}
        />
      </div>
    </div>
  </div>
);

export default TelephoneField;
